<app-dialog
  customClass="enable-stripe-verification-wrapper"
  [dialogType]="dialogType"
  [stackActions]="false"
  [primaryActionText]="
    'DIALOG.PAYMENTS.LABEL.RESEND_VERIFICATION_EMAIL' | translate
  "
  [secondaryActionText]="'DIALOG.PAYMENTS.LABEL.LEARN_MORE' | translate"
  (onPrimaryAction)="onResendEmail()"
  (onSecondaryAction)="goToLearnMore()"
>
  <div class="enable-stripe-dialog">
    <app-icon
      class="enable-stripe-canvas-icon"
      [icon]="enabledStripeVerificationIcon"
    >
    </app-icon>

    <div class="contents">
      <div class="title">
        {{
          'DIALOG.PAYMENTS.DESCRIPTION.ENABLE_STRIPE_VERIFICATION' | translate
        }}
      </div>

      <p class="description">
        {{ 'DIALOG.PAYMENTS.DESCRIPTION.STRIPE_ONBOARDING_1' | translate }}
      </p>

      <p class="description">
        {{ 'DIALOG.PAYMENTS.DESCRIPTION.STRIPE_ONBOARDING_2' | translate }}
      </p>
    </div>
  </div>
</app-dialog>
